// extracted by mini-css-extract-plugin
module.exports = {"sectionList":"SectionList_sectionList__amp2q","sectionList__condensed":"SectionList_sectionList__condensed__2wVL_"};